var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveygeneralexit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9599 2.99414H6.0642C3.95301 2.99414 2.89742 2.99414 2.24155 3.65C1.58569 4.30587 1.58569 5.36146 1.58569 7.47265V7.9205M6.9599 16.4297H6.0642C3.95301 16.4297 2.89742 16.4297 2.24155 15.7738C1.58569 15.1179 1.58569 14.0623 1.58569 11.9512V11.5033",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1318 1.06604C9.19518 0.728271 8.22693 0.559387 7.59345 1.12098C6.95996 1.68258 6.95996 2.70986 6.95996 4.76443V14.6594C6.95996 16.714 6.95996 17.7413 7.59345 18.3029C8.22693 18.8645 9.19518 18.6955 11.1318 18.3578L13.2177 17.994C15.3624 17.6199 16.4348 17.4329 17.0716 16.6462C17.7084 15.8596 17.7084 14.7218 17.7084 12.4464V6.97744C17.7084 4.70201 17.7084 3.56429 17.0716 2.77764C16.6461 2.25192 16.026 1.994 15.0213 1.76909",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveygeneralexit);
export default __webpack_public_path__ + "static/media/surveygeneralexit.29064711c2b4644f063a4a24729fbbd6.svg";
export { ForwardRef as ReactComponent };